/**
 * @param {string} locales A string with a BCP 47 language tag or an Intl.Locale instance, or an array of such locale identifiers.
 * @param {Object} options
 */
function getNumberFormatter(locales, options) {
    return new Intl.NumberFormat(locales, options)
}

const LOCALES = {
    EN_US: 'en-US'
}

export { getNumberFormatter, LOCALES }
